export const staticText = {
  appHeader: {
    notifications: {
      title: "Notifications",
    },
    userMenu: {
      userTooltip: "Edit details",
      profile: "Profile",
      orgs: "My organizations",
      team: "Manage team",
      help: "Help center",
      signOut: "Log out",
      subscription: {
        noActivePlan: "No active subscription",
        subscribeNow: "No active subscription - subscribe now",
      },
    },
    controlCenter: {
      title: "Control Center",
    },
    drawers: {
      customerSupport: {
        title: "CONTACT STUDIO SUPPORT",
        textAreaLabel: "Question",
        selectLabel: "Category",
        selectPlaceholder: "Select a category",
        submitButton: "Submit",
        descriptionOne: "Have a question or issue?",
        descriptionTwo:
          "Let us know below, and we’ll aim to reply within 24 hours.",
        confirmationTitle: "Message Sent",
        confirmationBody: "Your message has been sent to customer support.",
        categories: {
          invitingNewUsersToStudio: "Inviting new users to studio",
          connectingMySocialChannels: "Connecting my social channels",
          managingMyLibraryLicenses: "Managing my library licenses",
          generalPlatformSupport: "General platform support",
          whereCanIUseTheMusic: "Where can I use the music",
          licenseMusicOutsideTheStudioLibrary:
            "License music outside the Studio library",
          creativeServicesFromMassiveMusic:
            "Creative services from MassiveMusic",
          other: "Other",
        },
      },
    },
  },
  controlCenter: {
    title: "SWITCH BETWEEN MUSIC TOOLS OR EXPLORE OUR SERVICES.",
    tile: {
      activeStatus: "Active",
    },
  },
};
